const BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export function logClientError(error, context = {}) {
  const token = localStorage.getItem("token");

  if (!token) return;

  fetch(`${BASE_URL}/error-logs`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      source: "frontend",
      severity: "ERROR",
      message: error?.message || String(error),
      stack: error?.stack,
      route: window.location.pathname,
      status: error?.status,
      metadata: context,
    }),
  }).catch(() => {});
}
